/**
 * /app/$tenantSlug/me/account/notifications — Me → Account → Notifications
 * (N1, 2026-10-21). Every role: my notification preferences (G9, category ×
 * channel) and my calendar feed (G12). Both endpoints are scoped to the
 * calling user, so there is no role or feature gate.
 *
 * Moved from /settings/notifications (which now redirects here): Settings
 * is an HR-admin sidebar item, so employees and managers could not reach
 * their own preferences from the menus.
 */

import { createFileRoute } from "@tanstack/react-router";
import { Bell } from "lucide-react";
import { AccountShell } from "@/components/shared/account-shell";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { NotificationPrefsForm } from "@/components/settings/notification-prefs-form";
import { CalendarFeedCard } from "@/components/settings/calendar-feed-card";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/account/notifications")({
  component: MyNotificationsRoute,
});

function MyNotificationsRoute() {
  return (
    <AccountShell description="Choose what reaches you, and where. Changes apply to you only, straight away.">
      <div className="max-w-3xl space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <Bell aria-hidden className="h-4 w-4 text-primary" />
              What You Hear About
            </CardTitle>
            <CardDescription>
              Everything is on to start with. Untick a box to stop that kind of
              notice by email or in the app.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <NotificationPrefsForm />
          </CardContent>
        </Card>

        <CalendarFeedCard />
      </div>
    </AccountShell>
  );
}
